<template>

    <modal :show="showModal" @closeModal="close">

        <div class="flex-collumn padding-modal">

            <img class="modal-cancel" src="/img/icons/cancel-grey.svg" @click="close" alt="cancel">

            <h2 class="mep-title">{{ $t('unsupported_provider_title') }}</h2>

            <span class="mep-email">{{ email }}</span>

            <span class="mep-text">{{ computedModalText }}</span>

            <div class="bloc-foxy">

                <img class="mep-img-foxy" src="/img/foxy/glasses.svg" alt="foxy's glasses">

                <span class="mep-improve">{{ $t('unsupported_provider_help') }}</span>

                <a class="link mep-link" @click="help">{{ $t('unsupported_provider_contact') }}</a>

            </div>

        </div>

    </modal>

</template>

<script>

import Mailto from '@/modules/mailTo'
import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-provider',

    components: { Modal },

    props: {
        email: {
            type: String,
            default: ''
        },

        provider: {
            type: String,
            default: ''
        }
    },

    computed: {

        computedModalText: function () {

            return this.shutdown ? this.$tc('login_provider_impossible_to_connect', 0, {provider: this.selfProvider}) : this.$t('unsupported_provider_text')
        }
    },

    data () {
        return {
            showModal: false,
            shutdown: false,
            selfProvider: ''
        }
    },

    methods: {

        show (error) {

            this.selfProvider = this.provider

            Tag.popupAmplitude(this, 'unknown_provider')

            if(error && error.data && error.data.reason === 'shutdown') {
                this.selfProvider = error.data.provider
                this.shutdown = true
            }
            this.showModal = true
        },

        close () {
            this.showModal = false
        },

        help () {

            Mailto.help()
        }

    }

}

</script>

<style scoped lang="scss">

    .modal-cancel {
        position: absolute;
        top: 16px;
        left: 16px;
        cursor: pointer;
    }

    .mep-title {
        font-size: 28px;
        font-weight: 600;
    }

    .mep-email {
        margin-top: 7px;
        font-size: 16px;
        line-height: 1.5;
        text-align: center;
        font-weight: bold;
        color: $raspberry;
    }

    .mep-text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        text-align: center;
        max-width: 480px;
    }

    .bloc-foxy {
        margin-top: 17px;
        padding-bottom: 12px;
        background-color: $grey-bg;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .mep-img-foxy {
        margin-top: 8px;
        width: 64px;
        height: 64px;
        object-fit: contain;
    }

    .mep-improve {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 600;
    }

    .mep-link {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 500;
    }

    .padding-modal {
        padding: 15px 16px;
    }


</style>
